import React from "react";
import { connect } from "react-redux";
import {} from "../../../Redux/Actions/actions";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};
const HospitalityComponent = (props) => {
  return (
    <div className="d-flex justify-content-center h-100 w-100">
      <iframe
        src={`https://release.edayaapp.com/inaipiGuestDetailsCheck?emailOrMobile=${
          props.externalChatData
            ? props.externalChatData.unique_id
              ? props.externalChatData.unique_id.phonenumber
              : ""
            : ""
        }`}
        style={{ width: "100vw", height: "90vh" }}
      ></iframe>
    </div>
  );
};
export default connect(mapStateToProps, {})(HospitalityComponent);
